"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSendPropertyOwnerNotificationBodyDto = instanceOfSendPropertyOwnerNotificationBodyDto;
exports.SendPropertyOwnerNotificationBodyDtoFromJSON = SendPropertyOwnerNotificationBodyDtoFromJSON;
exports.SendPropertyOwnerNotificationBodyDtoFromJSONTyped = SendPropertyOwnerNotificationBodyDtoFromJSONTyped;
exports.SendPropertyOwnerNotificationBodyDtoToJSON = SendPropertyOwnerNotificationBodyDtoToJSON;
exports.SendPropertyOwnerNotificationBodyDtoToJSONTyped = SendPropertyOwnerNotificationBodyDtoToJSONTyped;
/**
 * Check if a given object implements the SendPropertyOwnerNotificationBodyDto interface.
 */
function instanceOfSendPropertyOwnerNotificationBodyDto(value) {
    if (!('crm_property_id' in value) || value['crm_property_id'] === undefined)
        return false;
    if (!('subject' in value) || value['subject'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    if (!('deepLink' in value) || value['deepLink'] === undefined)
        return false;
    return true;
}
function SendPropertyOwnerNotificationBodyDtoFromJSON(json) {
    return SendPropertyOwnerNotificationBodyDtoFromJSONTyped(json, false);
}
function SendPropertyOwnerNotificationBodyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'crm_property_id': json['crm_property_id'],
        'subject': json['subject'],
        'message': json['message'],
        'deepLink': json['deepLink'],
    };
}
function SendPropertyOwnerNotificationBodyDtoToJSON(json) {
    return SendPropertyOwnerNotificationBodyDtoToJSONTyped(json, false);
}
function SendPropertyOwnerNotificationBodyDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'crm_property_id': value['crm_property_id'],
        'subject': value['subject'],
        'message': value['message'],
        'deepLink': value['deepLink'],
    };
}
